module.exports = __webpack_public_path__ + "img/earth.529c6f75.gif";